import { Injectable } from '@angular/core';

export const environment = {
    api_url: 'https://test.api.custhelper.com',
    app_version: '5.3.0'
};

@Injectable({
    providedIn: 'root'
})
export class Environment {
    public api_url: string = environment.api_url;
    public app_version: string = environment.app_version;

    public status(index: number) {
        console.log('Getting status for index: ' + index);
        let statuses = [
            {key: 0, value: 'pending'},
            {key: 1, value: 'approved'},
            {key: 2, value: 'cancelled'},
            {key: 3, value: 'pending_kgh'},
            {key: 4, value: 'done_by_kgh'},
            {key: 5, value: 'approved'},
            {key: 6, value: 'done_by_kgh'},
            {key: 7, value: 'declared_by_toll'},
            {key: 9, value: 'waiting_transit_request'},
            {key: 10, value: 'waiting_transit_request'},
            {key: 11, value: 'transit_approval'},
            {key: 12, value: 'await_border_approval'},
            {key: 13, value: 'ready_for_border_approval'}
        ];

        let status = statuses.find(status => status.key == index);
        if(status) {
            console.log("Found status: " + status['value']);
            return status['value'];
        }
        return '';
    }

    public getBaseUrl(segment: string) {
        return this.api_url + segment;
    }

    public getVersionNumber() {
        let number = this.app_version.replace(/\./g, '');
        return number;
    }

    public getUrl(segment: string) {
        return this.api_url + '/client' +  segment;
    }
}
